var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBox(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.048 2.24l-4.32 3.68H3.648v20.384h20.064v-8.736l3.616-4.288v14.88c0 .96-.736 1.76-1.664 1.824l-.16.032H1.824c-.96 0-1.728-.768-1.824-1.696V4.064c0-.96.736-1.76 1.664-1.824h24.384zm2.112.352c.96-.864 2.4-.768 3.264.192.736.832.768 2.112.096 2.976l-.128.16-14.816 16.384c-1.184 1.312-3.2 1.376-4.48.192a2.07 2.07 0 01-.256-.288l-.128-.16-5.088-6.784c-.992-1.312-.736-3.136.544-4.096 1.12-.896 2.688-.768 3.68.16l.128.128 3.456 3.712L28.16 2.592z"
  })));
}

export default SvgCheckBox;